import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { NumberUtils } from "@mra/hlp9002";
import { TypeFormRevenuRegulier } from "src/app/pages/parcours-simulation/ma-simulation/prest-simulateur-conso/preco-mapper.service";

export const MIN_RPP_MONTANT: number = 2400;
export const MIN_RPP_DUREE: number = 2;

export function RppValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control?.parent) return null;

        const formGroup: FormGroup<TypeFormRevenuRegulier> = control.parent as FormGroup;
        const erreur: string[] = [
            `Le minimum doit être à 
            ${NumberUtils.formatterMonnaie(MIN_RPP_MONTANT / MIN_RPP_DUREE)}
            sur ${MIN_RPP_DUREE} ans,
            soit ${NumberUtils.formatterMonnaie(MIN_RPP_MONTANT)}`
        ];

        const res: number = formGroup.value.duree * Number(control.value ?? 0);
        if (res === 0) return null;
        if (res >= MIN_RPP_MONTANT && formGroup.value.duree >= MIN_RPP_DUREE) return null;
        return { rppInvalid: erreur[0] };
    };
}
